import { ResponseType } from 'axios';
import { HTTP_METHOD, ENDPOINT } from 'src/constants/api';
import { IAccountOnboardingDetail, IBankAccount, IEmploymentDetail, ISuportingDocument } from 'src/interfaces/accounts/account';
import { ICompanyInfo, ICompanyLevelDocument } from 'src/interfaces/accounts/company';
import { DTO } from './base.dto';

export interface IAccountChangeBasicInfoBody {
	firstName?: string;
	middleName?: string;
	lasttName?: string;
	companyName?: string;
}

export class ChangeBasicInformationResponse {
	token?: string;
	constructor(data: { token: string }) {
		this.token = data.token;
	}
}

export class AccountChangeBasicInfoDTO extends DTO {
	public param: object | undefined;
	public query: undefined;
	public body: IAccountChangeBasicInfoBody;
	public url: string = ENDPOINT.UPDATE_BASIC_INFORMATION;
	public method: HTTP_METHOD = HTTP_METHOD.PUT;
	public readonly responseClass = ChangeBasicInformationResponse;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IAccountChangeBasicInfoBody) {
		super();
		this.body = body;
	}
}

export interface IUpdatePasswordBody {
	currentPassword: string;
	newPassword: string;
	newPasswordConfirm: string;
}

export class AccountChangePasswordDTO extends DTO {
	public param: object | undefined;
	public query: undefined;
	public body: IUpdatePasswordBody;
	public url: string = ENDPOINT.CHANGE_PASSWORD;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseClass = String;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IUpdatePasswordBody) {
		super();
		this.body = body;
	}
}

export class OnboardingRequestResponse {
	onboardingId?: string;
	type?: number;
	status?: number;
}

export class AccountInfoResponse {
	fistName?: string;
	middleName?: string;
	lastName?: string;
	email?: string;
	companyName?: string;
	funderOnboardingRequest?: OnboardingRequestResponse;
	borrowerOnboardingRequest?: OnboardingRequestResponse;
	accountOnboardingDetailResponse?: IAccountOnboardingDetail;
	companyInfo?: ICompanyInfo;
	individualFunderSupportingDocuments?: ISuportingDocument;
	individualBorrowerSupportingDocuments?: ISuportingDocument;
	corporateFunderLevelDocuments?: ICompanyLevelDocument;
	corporateBorrowerLevelDocuments?: ICompanyLevelDocument;
	funderRequestSubmitDate?: Date;
	borrowerRequestSubmitDate?: Date;
	employmentDetail?: IEmploymentDetail;
	bankAccount?: IBankAccount;
	eSignedDocument?: ISuportingDocument
}

export class AccountInfoDTO extends DTO {
	public param: object | undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.ACCOUNT_INFO;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseClass = AccountInfoResponse;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}

export class SignPlatformUsageDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: { accountId: string; type: string };
	public url: string = ENDPOINT.SIGN_PLATFORM_USAGE;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseClass = AccountInfoResponse;
	public readonly responseType: ResponseType = 'json';
	constructor(body: { accountId: string; type: string }) {
		super();
		this.body = body;
	}
}
